/**
 * Module Client #04 — Suivi temps réel & calendrier
 */
const moduleClientSuivi = {
  id: 'client-suivi-temps-reel',
  population: 'client',
  order: 4,
  category: 'Opérations',
  title: 'Suivi temps réel & calendrier',
  subtitle: 'Visualiser et anticiper tous vos flux en un coup d\'œil',
  icon: 'Zap',
  duration: '15 min',
  level: 'Débutant',
  slides: [
    { type: 'cover', eyebrow: 'Module 04 — Client', title: 'Suivi temps réel', subtitle: 'Carte GPS + planning calendaire', icon: 'Zap', duration: '15 min', audience: 'Tous', level: 'Débutant' },
    { type: 'intro', title: 'Objectifs', intro: 'Le module Suivi vous offre 2 vues complémentaires : la carte GPS temps réel et le calendrier de vos opérations à venir.', objectives: [
      'Lire la carte de suivi avec position GPS toutes les 30 s',
      'Comprendre les codes couleur des marqueurs véhicules',
      'Recevoir les alertes proximité (camion à 10 km de l\'arrivée)',
      'Naviguer dans le calendrier (jour, semaine, mois)',
      'Replay du trajet complet après livraison',
    ]},
    { type: 'concept', eyebrow: 'Codes couleur', icon: 'BookOpen', title: 'Les marqueurs sur la carte',
      bullets: [
        '🟢 Vert : véhicule en route, dans les délais',
        '🟡 Jaune : véhicule à l\'arrêt < 30 min (pause, péage)',
        '🟠 Orange : véhicule à l\'arrêt > 30 min (à investiguer)',
        '🔴 Rouge : véhicule en retard ou incident signalé',
        '⚫ Gris : véhicule hors-réseau (en zone blanche)',
      ],
      note: 'Cliquez un marqueur pour voir : opération, chauffeur, ETA, dernière position connue.',
    },
    { type: 'steps', title: 'Suivre une opération en direct', steps: [
      { title: 'Menu "Suivi temps réel"', detail: 'Sidebar gauche, icône éclair.' },
      { title: 'Filtrer par opération ou plaque', detail: 'Recherche rapide en haut.' },
      { title: 'Cliquer sur le marqueur', detail: 'Panneau latéral avec infos chauffeur, ETA, photos.' },
      { title: 'Activer "Alerte proximité"', detail: 'Notification push quand le camion est à 10 km.' },
    ]},
    { type: 'comparison', title: 'Carte vs Calendrier', do: [
      'Carte : visualiser les positions actuelles',
      'Carte : recevoir les alertes proximité',
      'Calendrier : planifier la réception marchandise',
      'Calendrier : voir le plan de charge sur la semaine',
    ], dont: [
      'Ne pas confondre ETA prévisionnel et arrivée réelle',
      'Ne pas oublier d\'activer les notifications navigateur',
      'Ne pas paniquer si véhicule passe en gris (zone blanche)',
      'Ne pas appeler le chauffeur en conduite (utiliser la messagerie)',
    ]},
    { type: 'quiz', title: 'Quiz',
      question: 'Le marqueur de votre véhicule passe en gris. Que se passe-t-il ?',
      options: [
        'Le chauffeur a éteint l\'app',
        'Le véhicule est dans une zone sans réseau (GSM/GPS faible)',
        'Le camion est en panne',
        'L\'opération est annulée',
      ],
      answerIndex: 1,
      explanation: 'Le gris = perte de signal GPS/GSM. La position revient automatiquement dès que le réseau revient. Aucune action requise.',
    },
    { type: 'takeaways', title: 'À retenir', items: [
      'Position GPS rafraîchie toutes les 30 s.',
      'Codes couleur = état de la livraison.',
      'Alerte proximité = anticipation accueil.',
      'Calendrier = planification mensuelle.',
      'Replay disponible après chaque livraison.',
    ]},
    { type: 'cta', title: 'Module 04 terminé !', actions: [
      { label: 'Ouvrir le suivi', href: '/suivi' },
      { label: 'Catalogue', href: '/docs/client/training' },
    ]},
  ],
};
export default moduleClientSuivi;
